module.exports = __webpack_public_path__ + "img/icon_search.559ac69c.svg";